import { RoleModuleConfig } from './types';
import { ExternalUserSubjectsSlice } from '@restore/ExternalUserSubjects/ExternalUserSubjects.slice';
import { ExternalUserSubjectsSaga } from '@restore/ExternalUserSubjects/ExternalUserSubjects.saga';
import { ExternalUserReportsSlice } from '../ExternalUserReports/ExternalUserReports.slice';
import { ExternalUserReportsSaga } from '../ExternalUserReports/ExternalUserReports.saga';

// Reading-related slices (needed for ReadingTaskViewerPage)
import { DXAScoringFormSlice } from '@restore/DXAScoringForm/DXAScoringForm.slice';
import { measurementsSlice } from '@restore/measurements/measurements.slice';
import { DICOMViewerSlice } from '@restore/DICOMViewer/DICOMViewer.slice';
import { readerTaskSlice } from '@restore/readerTask/readerTask.slice';
import { readerSubTaskSlice } from '@restore/readerSubTask/readerSubTask.slice';
import { readerTaskOrchestrationSlice } from 'src/store-redux/readerTaskOrchestration/readerTaskOrchestration.slice';
import { clinicalTrialInventorySlice } from '@restore/clinicalTrialInventory/clinicalTrialInventory.slice';
import { formManagementSlice } from '../readerViewerSession/formManagement/formManagement.slice';
import { tabCoordinationSlice } from '../readerViewerSession/tabCoordination/tabCoordination.slice';
import { segmentationSlice } from '@restore/segmentation/segmentation.slice';

// Reading-related sagas
import { DXAScoringFormSaga } from '@restore/DXAScoringForm/DXAScoringForm.saga';
import { measurementsSaga } from '@restore/measurements/measurements.saga';
import { DICOMViewerSaga } from '@restore/DICOMViewer/DICOMViewer.saga';
import { readerTaskSaga } from '@restore/readerTask/readerTask.saga';
import { readerSubTaskSaga } from '@restore/readerSubTask/readerSubTask.saga';
import { readerTaskOrchestrationSaga } from 'src/store-redux/readerTaskOrchestration/readerTaskOrchestration.saga';
import { clinicalTrialInventorySaga } from '@restore/clinicalTrialInventory/clinicalTrialInventory.saga';
import { formManagementSaga } from 'src/store-redux/readerViewerSession/formManagement/formManagement.saga';
import { tabCoordinationSaga } from '../readerViewerSession/tabCoordination/tabCoordination.saga';
import { segmentationSaga } from '@restore/segmentation/segmentation.saga';

export const externalUserModules: RoleModuleConfig = {
  slices: [
    ExternalUserSubjectsSlice,
    ExternalUserReportsSlice,
    // Reading viewer slices
    clinicalTrialInventorySlice,
    DXAScoringFormSlice,
    measurementsSlice,
    DICOMViewerSlice,
    readerTaskSlice,
    readerSubTaskSlice,
    readerTaskOrchestrationSlice,
    tabCoordinationSlice,
    formManagementSlice,
    segmentationSlice,
  ],
  sagas: {
    ExternalUserSubjectsSaga,
    ExternalUserReportsSaga,
    // Reading viewer sagas
    DXAScoringFormSaga,
    measurementsSaga,
    DICOMViewerSaga,
    readerTaskSaga,
    readerSubTaskSaga,
    readerViewerPageSaga: readerTaskOrchestrationSaga,
    clinicalTrialInventorySaga,
    tabCoordinationSaga,
    formManagementSaga,
    segmentationSaga,
  },
};
